__webpack_require__.p = "/Configure-tariff/";